import React from 'react';

import {
  StyledSlider, Ticks, Tick, StyledRangeInput,
} from './styles';

type SliderProps = {
  value: number,
  onValueChange: void,
  ticks: Array,
};

const Slider = ({ value, onValueChange, ticks }: SliderProps) => (
  <StyledSlider>
    <StyledRangeInput
      type="range"
      min={-2}
      max={2}
      value={value !== undefined ? value : 0}
      onChange={e => onValueChange(e.target.value)}
    />
    <Ticks>
      {ticks.map(({ tickValue, tickLabel }) => (
        <Tick
          key={tickValue}
          isActive={+tickValue === (+value || 0)}
          onClick={() => onValueChange(tickValue)}
        >
          <span>{tickLabel}</span>
        </Tick>
      ))}
    </Ticks>
  </StyledSlider>
);

export default Slider;
